import { __awaiter, __generator } from "tslib";
import { isFunc, mergeOptions, objectDefinedNotNull } from "@pnp/common";
import { defaultPipelineBinder, cloneQueryableData } from "@pnp/odata";
import { GraphHttpClient } from "./graphhttpclient.js";
import { toAbsoluteUrl } from "./utils/toabsoluteurl.js";
export function registerCustomRequestClientFactory(requestClientFactory) {
    httpClientFactory = isFunc(requestClientFactory) ? function () { return requestClientFactory; } : defaultFactory;
}
var defaultFactory = function (runtime) { return function () { return new GraphHttpClient(runtime); }; };
var httpClientFactory = defaultFactory;
var send = function (method) {
    return function (o, options) {
        return __awaiter(this, void 0, void 0, function () {
            var runtime, operation, data, batchDependency, url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        runtime = o.getRuntime();
                        operation = defaultPipelineBinder(httpClientFactory(runtime))(method);
                        data = cloneQueryableData(o.data);
                        batchDependency = objectDefinedNotNull(data.batch) ? data.batch.addDependency() : function () {
                            return;
                        };
                        return [4 /*yield*/, toAbsoluteUrl(o.toUrlAndQuery(), runtime)];
                    case 1:
                        url = _a.sent();
                        mergeOptions(data.options, options);
                        return [2 /*return*/, operation(Object.assign({}, data, {
                                batchDependency: batchDependency,
                                url: url,
                            }))];
                }
            });
        });
    };
};
export var graphGet = function (o, options) { return send("GET")(o, options); };
export var graphPost = function (o, options) { return send("POST")(o, options); };
export var graphDelete = function (o, options) { return send("DELETE")(o, options); };
export var graphPatch = function (o, options) { return send("PATCH")(o, options); };
export var graphPut = function (o, options) { return send("PUT")(o, options); };
//# sourceMappingURL=operations.js.map